import dashboardCustomerManagement from "../../../../assets/icons/dashboardCustomerManagement.svg";
import dashboardLeadManagement from "../../../../assets/icons/dashboardLeadManagement.svg";
import dashboardCampaignManagement from "../../../../assets/icons/dashboardCampaignManagement.svg";
import dashboardSurveys from "../../../../assets/icons/dashboardSurveys.svg";
import dashboardUserManagement from "../../../../assets/icons/dashboardUserManagement.svg";
import dashboardReportsInsights from "../../../../assets/icons/dashboardReportsInsights.svg";
// import dashboardPartnerManagementIcon from "../../../../assets/icons/dashboard_partner_management_icon.svg";
// import dashboardTemplatesIcon from "../../../../assets/icons/dashboard_templates_icon.svg";
import dashboardGuidesIcon from "../../../../assets/icons/dashboardGuidesIcon.svg";
import dashboardPartnerManagementIcon from "../../../../assets/icons/dashboard-partner-management-icon.svg";
import dashboardTemplatesIcon from "../../../../assets/icons/dashboard-template-qr-icon.svg";
import { routes } from "../../../../constants/routes";

export const platformCRMCardsOne = [
  {
    icon: dashboardLeadManagement,
    title: "Lead Management",
    isShowCard: true,
    key: "Lead Management",
    sections: [
      {
        sectionsName: "Lead Details",
        isShowSubCard: true,
        sectionsText:
          "View complete lead profiles with contact information, preferences, and interaction history — all in one place.",
        url: "/home/lead-management/lead-details",
      },
      {
        sectionsName: "Lead Capture",
        isShowSubCard: true,
        sectionsText:
          "Automatically collect leads from forms, websites, and social platforms with real-time source tracking.",
        url: "/home/lead-management/lead-capture-form",
      },
    ],
  },
  {
    icon: dashboardCustomerManagement,
    title: "Customer Management",
    isShowCard: true,
    key: "Customer Management",
    sections: [
      {
        sectionsName: "Customer Profile",
        isShowSubCard: true,
        sectionsText:
          "Access detailed customer profiles with contact info, preferences, and engagement history — all organized in one view.",
        url: "/home/customer-management/customer-list",
      },
      {
        sectionsName: "Customer Engagement",
        isShowSubCard: true,
        sectionsText:
          "Track and manage customer interactions across forms, email, and phone calls in real time.",
        url: "/home/customer-management/customer-engagement",
      },
    ],
  },
  {
    icon: dashboardCampaignManagement,
    title: "Campaign Management",
    isShowCard: true,
    key: "Campaigns",
    sections: [
      {
        sectionsName: "Create Campaigns",
        isShowSubCard: true,
        sectionsText:
          "Quickly create and launch marketing campaigns to reach and engage your customers.",
        url: "/home/campaigns/create-campaign",
      },
      {
        sectionsName: "Campaign Performance Metrics",
        isShowSubCard: true,
        sectionsText:
          "Measure campaign effectiveness with real-time insights and detailed performance tracking.",
        url: "/home/campaigns/campaign-performance-metrics",
      },
    ],
  },
];

export const platformCRMCardsTwo = [
  {
    icon: dashboardSurveys,
    title: "Surveys",
    isShowCard: true,
    key: "Surveys",
    sections: [
      {
        sectionsName: "Create Surveys",
        isShowSubCard: true,
        sectionsText:
          "Quickly build surveys to collect valuable feedback from leads and customers.",
        url: "/home/surveys/create-survey",
      },
      {
        sectionsName: "View Surveys",
        isShowSubCard: true,
        sectionsText:
          "Track responses and analyze survey results with built-in reporting tools.",
        url: "/home/surveys/view-survey",
      },
    ],
  },
  {
    icon: dashboardUserManagement,
    title: "User Management",
    isShowCard: true,
    key: "User Management",
    sections: [
      {
        sectionsName: "User Requests",
        isShowSubCard: true,
        sectionsText:
          "Manage incoming user access requests efficiently, with full visibility of their details.",
        url: "/home/user-management/user-requests",
      },
      {
        sectionsName: "User Roles & Permissions",
        isShowSubCard: true,
        sectionsText:
          "Control who can do what with customizable roles and secure permission settings.",
        url: "/home/user-management/user-management-role",
      },
    ],
  },
  {
    icon: dashboardReportsInsights,
    title: "Reports & Insights",
    isShowCard: true,
    key: "Usage Metrics / Utilization",
    sections: [
      {
        sectionsName: "Lead Reports",
        isShowSubCard: true,
        sectionsText:
          "Access complete lead profiles with contact info, preferences, and history — all in one place.",
        url: "/home/lead-management/lead-reports",
      },
      {
        sectionsName: "Campaign Reports",
        isShowSubCard: true,
        sectionsText:
          "Automatically collect leads from forms, websites, and social media with real-time source tracking.",
        url: "/home/campaigns/campaign-performance-metrics",
      },
    ],
  },
  {
    icon: dashboardPartnerManagementIcon,
    title: "Partner Management",
    isShowCard: true,
    key: "Partner Management",
    sections: [
      {
        sectionsName: "Partner List",
        isShowSubCard: true,
        sectionsText:
          "View, manage, and search the list of all partners with their details in a centralized interface.",
        url: routes.PARTNERLIST,
      },
      {
        sectionsName: "CRM Plans",
        isShowSubCard: true,
        sectionsText:
          "Manage and configure different CRM subscription plans (Basic, Intermediate, Advanced, Custom) with features and usage limits.",
        url: routes.CREATE_CRM_PLAN,
      },
    ],
  },
  {
    icon: dashboardTemplatesIcon,
    title: "Templates & QRs",
    isShowCard: true,
    key: "Templates & QRs",
    sections: [
      {
        sectionsName: "Email Templates",
        isShowSubCard: true,
        sectionsText:
          "Create, manage, import, and export reusable email and letter templates with customizable variables for consistent communication.",
        url: routes.EMAILTEMPLATES,
      },
      {
        sectionsName: "QR Codes List",
        isShowSubCard: true,
        sectionsText:
          "Generate, view, download, and manage QR codes for Landing Pages, Lead Capture Forms, and Surveys in a centralized listing.",
        url: routes.QRCODELIST,
      },
    ],
  },
  {
    icon: dashboardGuidesIcon,
    title: "Guides",
    isShowCard: true,
    key: "Guides",
    sections: [
      {
        sectionsName: "Tutorial Videos",
        isShowSubCard: true,
        sectionsText:
          "Access video tutorials to help you navigate and utilize the platform effectively.",
        url: routes.GUIDES,
      },
      {
        sectionsName: "Request Support",
        isShowSubCard: true,
        sectionsText:
          "Reach out to AFP support team for assistance with any issues or questions you may have.",
        url: routes.CUSTOMERSUPPORT,
      },
      {
        sectionsName: "View Tickets",
        isShowSubCard: true,
        sectionsText:
          "View the status and details of all support tickets partners have submitted.",
        url: routes.SUPPORT_TICKETS,
      },
    ],
  },
];
